export function createLinePath(link) {
    var source = link.source, target = link.target, owidth = link.width;
    var width = Math.max(owidth, 1);
    var sourceLinks = source.sourceLinks;
    var targetLinks = target.targetLinks;
    var sourceX = source.x1;
    var targetX = target.x0;
    var sourceY = source.y0;
    var targetY = target.y0;
    for (var i = 0; i < sourceLinks.length; i++) {
        sourceY += sourceLinks[i].width;
        if (sourceLinks[i] === link) {
            break;
        }
    }
    for (var i = 0; i < targetLinks.length; i++) {
        targetY += targetLinks[i].width;
        if (targetLinks[i] === link) {
            break;
        }
    }
    return "M " + sourceX + "," + (sourceY - width) + " L" + targetX + "," + (targetY - width) + " L" + targetX + "," + targetY + " L" + sourceX + "," + sourceY + " z";
}
export function sankeyLinkVertical(link) {
    var sourceY = link.source.y1;
    var targetY = link.target.y0;
    var sourceX = link.y0;
    var targetX = link.y1;
    var distance = targetY - sourceY;
    var p1x = sourceX;
    var p1y = sourceY + distance / 2;
    var p2x = targetX;
    var p2y = targetY - distance / 2;
    return "M" + sourceX + " " + sourceY + " C " + p1x + " " + p1y + " " + p2x + " " + p2y + " " + targetX + " " + targetY;
}
